export const MODAL_NAMES = {
  TRADEIN_AU: 'TRADEIN_AU',
  TRADEIN_JP: 'TRADEIN_JP',
}
